import { createFileRoute, Link } from '@tanstack/react-router'
import { useQuery } from '@tanstack/react-query'

import { Page } from '@/components/page'
import { CabinetMap } from '@/features/cabinets/CabinetMap'
import { fetchGrids, gridsKey } from '@/features/cabinets/api'

export const Route = createFileRoute('/locations/')({ component: StoragePage })

/**
 * Storage lands on the cabinets (screen 3c): every cabinet as a map with one
 * search across them; a tap opens that cabinet at the drawer.
 */
function StoragePage() {
  const grids = useQuery({ queryKey: gridsKey(''), queryFn: () => fetchGrids('') })
  const none = grids.data !== undefined && grids.data.length === 0
  return (
    <Page title="Storage" description="Where things live.">
      <CabinetMap />
      {none && (
        <p className="border border-dashed border-neutral-400 p-8 text-center text-sm text-neutral-600">
          No cabinets yet. Draw one with New cabinet, or{' '}
          <Link to="/locations/manage" className="text-steel-700">
            add places one by one
          </Link>
          .
        </p>
      )}
    </Page>
  )
}
